/* eslint-disable camelcase -- Stream Chat attachment fields use snake_case */
import { ComponentType, CSSProperties } from 'react';
import { Card, CardProps } from 'stream-chat-react';
import CustomImage from '../CustomImage/CustomImage';

/**
 * Stream treats image attachments with og_scrape_url as link cards, which adds
 * a URL footer over the image. Uploaded images should render as plain images.
 */
const CustomCard: ComponentType<CardProps> = props => {
	const { image_url, thumb_url, type } = props;

	if (type === 'image' && (image_url || thumb_url)) {
		return (
			<CustomImage
				fallback={props.title || props.fallback}
				image_url={image_url}
				thumb_url={thumb_url}
				previewUrl={props.previewUrl as string | undefined}
				style={props.style as CSSProperties | undefined}
			/>
		);
	}

	return <Card {...props} />;
};

export default CustomCard;
